import {createApp} from 'vue'
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import 'primeicons/primeicons.css'

const app = createApp(App)

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.dark',
        }
    }
});

app.use(router)

app.component('PrimeCard', Card)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('PrimeDropdown', Dropdown)
app.component('PrimeButton', Button)
app.component('PrimeInputText', InputText)

app.mount('#app')